import { BaseEntity } from "../base/base-entity";
export type SurveyImportStatusType = {
  readonly hasDuplicateCustomPath: boolean;
  readonly hasInvalidJson: boolean;
  readonly hasInvalidFormSchema: boolean;
  readonly hasInvalidZip: boolean;
  readonly hasInvalidFileVersion: boolean;
};

export class SurveyImportStatus extends BaseEntity {
  public readonly hasDuplicateCustomPath: boolean;
  public readonly hasInvalidJson: boolean;
  public readonly hasInvalidFormSchema: boolean;
  public readonly hasInvalidZip: boolean;
  public readonly hasInvalidFileVersion: boolean;

  constructor(props: SurveyImportStatusType) {
    super();
    this.hasDuplicateCustomPath = props.hasDuplicateCustomPath;
    this.hasInvalidJson = props.hasInvalidJson;
    this.hasInvalidFormSchema = props.hasInvalidFormSchema;
    this.hasInvalidZip = props.hasInvalidZip;
    this.hasInvalidFileVersion = props.hasInvalidFileVersion;
  }

  static fromJSON(json: SurveyImportStatusType) {
    return new SurveyImportStatus(json);
  }
}
